export const WORDS = [
  'CLOCK',
  'TORCH',
  'TOWEL',
  'STOOL'
];

export const WORD_IMAGES = {
  'CLOCK': 'clock.jpg',
  'TORCH': 'torch.jpg',
  'TOWEL': 'towel.jpg',
  'STOOL': 'stool.jpg'
};

/*'about', 'above', 'abuse', 'actor', 'acute', 'admit', 'adopt', 'adult',
'after', 'again', 'agent', 'agree', 'ahead', 'alarm', 'album', 'alert',
'alike', 'alive', 'allow', 'alone', 'along', 'alter', 'among', 'anger',
'angle', 'angry', 'apart', 'apple', 'apply', 'arena', 'argue', 'arise',
'array', 'aside', 'asset', 'audio', 'audit', 'avoid', 'award', 'aware',
*/
// Add more 5-letter words as needed